<script lang="ts">
    import RewardsActionButton from "@apps/rewards/components/Buttons/RewardsActionButton.svelte";
    import CN from "classnames";
    import { fade, fly } from "svelte/transition";

    //Optional Props
    export let isCustomer = false;
    export let isCompleted = false;
    export let canOpenModal = false;
    export let isDesignMode: boolean | null = null;
    export let dataGwSelector: string | undefined = undefined;
    export let className: string | null = null;
    export { className as class };

    //Variables
    let isHovered = false;

    //Handlers
    const handleMouseEnter = () => (isHovered = true);
    const handleMouseLeave = () => (isHovered = false);
</script>

<div
    class={CN("gw-rd-page-widget-card", className)}
    data-gw-selector={dataGwSelector}
    class:gw-rd-page-widget-card--cursor-pointer={isCustomer}
    class:gw-rd-page-widget-card--no-hover={isCustomer && !canOpenModal}
    class:gw-rd-page-widget-card--completed={isCompleted}
    on:mouseenter={handleMouseEnter}
    on:mouseleave={handleMouseLeave}
>
    <RewardsActionButton
        class="gw-rd-page-widget-card-btn--absolute"
        variant="link"
        on:click
    />
    <div class="gw-rd-page-widget-card__header">
        <div class="gw-rd-page-widget-card__icon">
            <slot name="icon" />
        </div>
        <slot name="title" />
    </div>
    <div class="gw-rd-page-widget-card__base-content">
        {#if isHovered && !isCustomer && !isDesignMode}
            <div in:fly={{ y: 30, duration: 200 }}>
                <slot name="auth-buttons" />
            </div>
        {:else if isCompleted}
            <slot name="completed" />
        {:else}
            <div in:fade={{ duration: 200 }}>
                <slot name="reward" />
            </div>
        {/if}
    </div>
</div>

<style lang="postcss">
    .gw-rd-page-widget-card {
        position: relative;
        height: 100%;
        display: grid;
        grid-auto-rows: max-content;
        gap: var(--gw-rd-space-6);
        box-sizing: border-box;
        padding: clamp(
            var(--gw-rd-space-6),
            -10.5px + 4.5vw,
            var(--gw-rd-space-12)
        );
        text-align: center;
        border: 2px solid var(--gw-rd-page-lightgrey-color);
        color: var(--gw-blue-text-color);
        background-color: var(--gw-white-bg);
        border-radius: var(--gw-rd-border-radius-md);
        transition: background-color 0.2s ease-in-out;

        &:hover {
            background-color: var(--gw-rd-page-lightgrey-color);

            .gw-rd-page-widget-card__icon {
                background-color: var(--gw-rd-page-lightgrey-color);
            }
        }

        &--no-hover {
            pointer-events: none;

            &:hover {
                background-color: var(--gw-white-bg);
            }
        }

        &--cursor-pointer {
            cursor: pointer;
        }

        & :global(.gw-rd-page-widget-card-btn--absolute) {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            width: -moz-available;
            z-index: 1;
            cursor: inherit;
        }

        &--completed {
            opacity: 0.8;
            pointer-events: none;
        }

        &__header {
            display: grid;
            justify-items: center;
            gap: var(--gw-rd-space-10);
            font-size: clamp(18px, 14px + 0.8vw, 20px);
            color: var(--gw-rd-primary-color);
        }

        &__icon {
            width: 60px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            background-color: var(--gw-rd-page-icon-bg-color);
            border-radius: 50%;
            transition: background-color 0.2s ease-in-out;
        }

        &__base-content {
            height: 48px;
            line-height: 24px;
            font-size: clamp(14.5px, 11.7px + 0.56vw, 16px);
            color: var(--gw-rd-secondary-color);

            :global(.gw-rd-discount-code-copy) {
                justify-content: center;
            }

            :global(.gw-rd-link) {
                position: relative;
                z-index: 1;
            }
        }
    }
</style>
